import React, { Fragment, useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
const spine = ['WEB', 'WHATSAPP', 'IA', 'CRM', 'AGENDA', 'SEGUIMIENTO'];
interface SpineChipProps {
  step: string;
  isActive: boolean;
}
function SpineChip({
  step,
  isActive
}: SpineChipProps) {
  return <span className={`font-body text-[12px] md:text-[13px] font-medium border rounded-full px-3.5 py-2 transition-all duration-300 whitespace-nowrap ${isActive ? 'bg-verde text-arena border-verde scale-[1.05]' : 'bg-arena/10 text-arena border-arena/10'}`} data-id="element-188" data-mp="2wyvbjafof8is">
      {step}
    </span>;
}
export function OriginSystem() {
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    amount: 0.4
  });
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    if (!isInView) return;
    const prefersReduced = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    const interval = setInterval(() => {
      setActiveIndex(i => (i + 1) % spine.length);
    }, 900);
    return () => clearInterval(interval);
  }, [isInView]);
  return <section id="arquitectura" className="bg-carbon py-[36px] md:py-[52px]" data-id="element-189" data-mp="iy5c4srqfaiw">
      <div className="max-w-[900px] mx-auto px-6 md:px-20" ref={containerRef} data-id="element-190" data-mp="dztzkaa1ylwz">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="font-display text-[20px] md:text-[26px] font-bold text-arena leading-[1.3] text-center max-w-[600px] mx-auto mb-8" data-id="element-191" data-mp="3mfxaqq0disq2">
          No construimos herramientas aisladas. Las conectamos para que
          trabajen como un solo sistema.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        ease: 'easeOut',
        delay: 0.1
      }} className="flex flex-wrap items-center justify-center gap-2 md:gap-2.5" data-id="element-192" data-mp="2yqm4it09864j">
          {spine.map((step, idx) => <Fragment key={step} data-id="element-193" data-mp="127dht0a2bob" data-mpi={idx}>
              <SpineChip step={step} isActive={idx === activeIndex} data-id="element-194" data-mp="60r1s02cfzju" />
              {idx < spine.length - 1 && <span className={`text-[13px] transition-colors duration-300 ${idx === activeIndex ? 'text-azul' : 'text-arena/25'}`} data-id="element-195" data-mp="35g5jqdup9zfg">
                  →
                </span>}
            </Fragment>)}
        </motion.div>
      </div>
    </section>;
}